import React from 'react'
import styled from 'styled-components'
import Checkbox from 'antd/lib/checkbox'
import { color } from '../styles'
import { Label } from './Label'
import { Spacer } from './Spacer'
import { TestingKey, insertTestingSelector } from '../util/testing'

type Props = {
    isChecked: boolean
    disabled?: boolean
    className?: string
    error?: string
    hasDanger?: boolean
    label?: string
    testingKeys?: [TestingKey] | [TestingKey, string]
    onChange: (nextChecked: boolean) => void
}

export const Check = (props: Props): JSX.Element => {
    const { onChange, isChecked, disabled, className, label, error, hasDanger, testingKeys } = props
    const testingSelectors = testingKeys?.length ? insertTestingSelector(...testingKeys) : {}
    return (
        <Container className={className}>
            <Checkbox
                {...testingSelectors}
                disabled={disabled}
                checked={isChecked}
                onChange={(nextCheck) => {
                    onChange(nextCheck.target.checked)
                }}
            />
            {label ? (
                <>
                    <Spacer size={2} />
                    <Label hasError={Boolean(error || hasDanger)}>{label}</Label>
                </>
            ) : null}
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    html {
        --antd-wave-shadow-color: ${color.text.primary};
    }
    .ant-checkbox-checked .ant-checkbox-inner {
        background-color: ${color.text.primary};
        border-color: ${color.text.primary};
    }

    && .ant-checkbox-inner:hover,
    && .ant-checkbox-inner:focus {
        border-color: ${color.text.primary};
        outline: transparent;
    }
    .ant-checkbox-checked::after,
    .ant-checkbox-input:focus + .ant-checkbox-inner,
    .ant-checkbox:hover .ant-checkbox-inner {
        border-color: ${color.text.primary};
        outline: transparent;
    }
    .ant-checkbox:active {
        opacity: 0.5;
    }
`
